import { assign } from 'lodash';

export default function reducer(state) {
  if (state === undefined) {
    return {};
  }
  return assign({}, state);
}
